import {eopCustomEvent} from "../../../../common/eventBus";

export const NAVIGATION_JUMP_INSIDE_PAGE_EVENT = "eop-navigation-jump-inside-page";

export type NavigationJumpInsidePageEvent = CustomEvent<string>;

export function navigationJumpInsidePageEvent(href: string): NavigationJumpInsidePageEvent {
    return eopCustomEvent(NAVIGATION_JUMP_INSIDE_PAGE_EVENT, href);
}